import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function BodyLanguage() {
  const navigate = useNavigate();

  const resources = [
    {
      title: "Canine Body Language",
      link: "https://drive.google.com/file/d/1nWOFhjYbtfPlebHG078ShbIGO_xFzM6P/view?usp=sharing",
    },
    {
      title: "CFORCE",
      link: "https://drive.google.com/file/d/1I33VS4FDtFa1tAMNVWxbAnY4SJ-gqfS2/view?usp=sharing",
    },
    {
      title: "Escalation Pyramid",
      link: "https://drive.google.com/file/d/1rZRONEsmrzWtWSEPI_nIJuyWXEQi4IL6/view?usp=sharing",
    },
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 p-8">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-4xl font-bold text-gray-800 mb-2">Canine Body Language</h1>
        <p className="text-lg text-gray-600 mb-8">
          Learn to observe and understand how your dog communicates stress, happiness, and everything in between.
        </p>

        <div className="grid sm:grid-cols-2 gap-4">
          {resources.map(({ title, link }) => (
            <a
              key={title}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-5 bg-white border border-gray-200 rounded-xl text-blue-600 hover:border-blue-400 hover:shadow transition text-center font-medium"
            >
              {title}
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

export default BodyLanguage;
